/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 11/08/2020.
 * @module APP ACTIONS
 */

import {
  BROWSE_ALL_STATION,
  BROWSE_OWN_STATION,
  BROWSE_OWN_COMPANY_STATION,
  BROWSE_REPOSITORIES,
  GET_All_HARDWARE,
  GET_All_STATION,
  GET_MENU,
  GET_STRICTED_ROUTE,
  GET_USER_STATION,
  SET_LIST_SERVER,
  BROWSE_STATION_V2
} from "./constants";
import { nanoid } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { createRoutine } from "redux-saga-routines";


/**
 * Action lấy danh sách kho
 */
export const browseRepositories = createRoutine(
  BROWSE_REPOSITORIES,
  payload => ({
    ...payload,
    actionId: nanoid(),
    createdAt: dayjs()
  })
);

export const browseAllStations = createRoutine(BROWSE_ALL_STATION, payload => ({
  ...payload,
  actionId: nanoid(),
  createdAt: dayjs()
}));

export const browseOwnStations = createRoutine(BROWSE_OWN_STATION, payload => ({
  ...payload,
  actionId: nanoid(),
  createdAt: dayjs()
}));
export const browseOwnCompanyStations = createRoutine(BROWSE_OWN_COMPANY_STATION, payload => ({
  ...payload,
  actionId: nanoid(),
  createdAt: dayjs()
}));
export const getAllMenu = createRoutine(GET_MENU, payload => ({
  ...payload,
  actionId: nanoid(),
  createdAt: dayjs()
}));
export const getStrictedRoute = createRoutine(GET_STRICTED_ROUTE, payload => ({
  ...payload,
  actionId: nanoid(),
  createdAt: dayjs()
}));
export const getUserStation = createRoutine(GET_USER_STATION, payload => ({
  ...payload,
  actionId: nanoid(),
  createdAt: dayjs()
}));
export const getAllStation = createRoutine(GET_All_STATION, payload => ({
  ...payload,
  actionId: nanoid(),
  createdAt: dayjs()
}));
export const getAllHardWare = createRoutine(GET_All_HARDWARE, payload => ({
  ...payload,
  actionId: nanoid(),
  createdAt: dayjs()
}));

export const setListServer = payload => ({
  type: SET_LIST_SERVER,
  payload
});

export const browseStationsV2 = createRoutine(BROWSE_STATION_V2, payload => ({
  ...payload,
  actionId: nanoid(),
  createdAt: dayjs()
}));
